import ReactDOM from "react-dom";
import React, { Component } from "react";
import SchoolSearch from "./SchoolSearch/index";

const init = () => {
  const elements = document.querySelectorAll("[data-school-search]");
  // loop through the menus and pass the template Data Accordingly
  elements.forEach(element => {
    ReactDOM.render(<SchoolSearch  />, element);
  });
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/schoolSearch.js